var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.67 4.5H14V3.5C14 2.95 13.55 2.5 13 2.5H11C10.45 2.5 10 2.95 10 3.5V4.5H8.33C7.6 4.5 7 5.1 7 5.83V21.16C7 21.9 7.6 22.5 8.34 22.5H15.66C16.4 22.5 17 21.9 17 21.17V5.83C17 5.1 16.4 4.5 15.67 4.5ZM14.61 13.74L11.94 18.74C11.7 19.19 11 19.02 11 18.5V15H9.83C9.45 15 9.21 14.6 9.39 14.26L12.06 9.26C12.3 8.81 13 8.98 13 9.5V13H14.17C14.54 13 14.79 13.4 14.61 13.74Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.5f1daf24260220a017550581d2197401.svg";
export { ForwardRef as ReactComponent };